<template>
  <div id="footer" :class="{'footer-option':this.$route.path !== '/','margin-top-auto':this.$route.path === '/'}">
    <div class="position-relative color py-7">

      <div class="width-100 font-color">
        <ul class="center-align pl-0" style="list-style-type: none;">
          <li class="font-bold font-medium-m line-height-m mb-1">クボタスピアーズアカデミー事務局</li>
          <li class="font-bold font-large-sm line-height-m mb-1"><a class="link-decoration-none font-color-white" :href="'tel:' + schoolSecretariatTel">03-3245-3080</a></li>
          <li class="font-bold font-medium-s mb-1">（電話受付時間：平日の9:00～15:30）</li>
        </ul>
        <div class="font-medium-s center-align">spears-call@kubota.com</div>

        <div class="line-width"></div>

        <div class="line-height-s center-align px-5 mt-6">
          <span @click="jumpTopPage" class="font-medium-s pointer">トップページ</span>
          <div class="line-height"></div>
          <span @click="jumpUseOfWebsite" class="font-medium-s pointer">ウェブサイトのご利用について</span>
          <div class="line-height"></div>
          <span @click="jumpSchoolRules" class="font-medium-s pointer">{{globalSchoolType}}規約</span>
          <div class="line-height"></div>
          <span @click="jumpPrivacyPolicy" class="font-medium-s pointer">プライバシーポリシー</span>
          <div class="line-height"></div>
          <span @click="jumpSpecificQuotient" class="font-medium-s pointer">特定商取引法に関する表示</span>
          <!--<div class="line-height"></div>-->
          <!--<span @click="jumpOfficialBlog" class="font-medium-s pointer">オフィシャルブログ</span>-->
        </div>

      </div>

      <div  @click="jumpOfficialSite" class="width-120 center-margin mt-4 primary-cursor">
        <!--<img v-lazy="footerLogoImg" class="footer-img">-->
      </div>

      <div class="center-align font-small-xl font-color pt-2">
        <div>本サイトで使用している文章・画像等の無断での複製・転載を禁止します。</div>
        <div>©{{globalSchoolNameEn}}</div>
        <div>©PIA CORPORATION</div>
        <div>©TEPCO SYSTEMS CORPORATION. All Rights Reserved.</div>
      </div>

    </div>
  </div>
</template>

<script>
import footerLogo from '@/assets/img/logo_4C_black.png'
export default {
  name: 'approach-footer',
  data: function () {
    return {
      footerLogoImg: footerLogo
    }
  },
  methods: {
    jumpTopPage: function () {
      if (this.eventTopList.filter(v => v === this.$route.name).length > 0) {
        window.location.href = '/event'
      } else {
        window.location.href = '/'
      }
    },
    jumpUseOfWebsite: function () {
      const self = this
      const fileName = 'other/クボタスピアーズ_webシステム利用規約.pdf'
      const windowReference = window.open()
      this.$store.commit('startLoading')
      this.globalGetManual(fileName).then(url => {
        self.$store.commit('finishLoading')
        if (url) {
          windowReference.location = url
        }
      })
    },
    jumpPrivacyPolicy: function () {
      const url = 'https://www.kubota-spears.com/privacy/'
      if (!window.open(url)) {
        window.location.href = url
      }
    },
    jumpOfficialBlog: function () {
      window.location.href = this.linkOfficialBlog
    },
    jumpOfficialSite: function () {
      window.location.href = this.linkOfficialSite
    },
    jumpSpecificQuotient: function () {
      window.location.href = '/specific-quotient'
    },
    jumpSchoolRules: function () {
      const self = this
      const fileName = 'other/クボタスピアーズ_アカデミー規約.pdf'
      const windowReference = window.open()
      this.$store.commit('startLoading')
      this.globalGetManual(fileName).then(url => {
        self.$store.commit('finishLoading')
        if (url) {
          windowReference.location = url
        }
      })
    }
  }
}
</script>

<style scoped>

.line-width {
  height: 1px;
  width: 56px;
  background-color: #fff;
  margin: 16px auto;
}

.line-height {
  display: inline-block;
  height: 10px;
  width: 1px;
  background-color: #fff;
  margin: auto 8px;
}

.footer-img{
  width: 100%;
  max-width: 100%;
  height: auto;
}

.logo-positon{
  position:absolute;
  bottom:20px;
  right:20px;
}

.color{
  background:#4B4B4B;
}

.font-color{
  color:white;
}

.footer-option{
  bottom:0;
}
.margin-top-auto{
  margin-top:auto;
}

@media(min-width: 768px){
  a[href^="tel:"]{
    pointer-events: none;
  }
}

img[lazy=loaded] {
animation-duration: 0.5s;
animation-fill-mode: both;
animation-name: scrollIn;
}

@keyframes scrollIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

</style>
